import { esRead } from '../../common/EsFetch';
import { esFormatList } from '../../common/EsIntl';
import { useEsStrings } from '../../common/EsStrings';

/**
 * The packs an account delete hides rather than deletes (V126): the account's own packs other
 * accounts built on, each with who built on it. The self-delete and the roster's delete both ask
 * about them first, and only when there are some.
 */

/** The list from esback, or empty when there is none or it cannot be read: esback still refuses the delete without the yes. */
export async function esReadForkedPacks( pPath ) {
    try {
        const aList = await esRead( pPath );
        return Array.isArray( aList ) ? aList.filter( ( pEach ) => typeof pEach?.name === 'string' ) : [];
    }
    catch {
        return [];
    }
}

export default function EsForkedPacks( { packs, 'data-testid': dataTestId } ) {
    const t = useEsStrings();

    return (
        <ul className="list-disc pl-6" data-testid={ dataTestId }>
            { packs.map( ( pPack ) => (
                <li key={ pPack.id ?? pPack.name } data-testid={ dataTestId + '-item' }>
                    { t( 'account-settings-delete-dialog-forked-item', '{pack}, built on by {names}',
                        { pack: pPack.name, names: esFormatList( pPack.forkers ?? [] ) } ) }
                </li>
            ) ) }
        </ul>
    );
}
